import GestaoFundoPropaganda from "views/adm-franquias/gestao-fundo-propaganda/page";

export default function FundoPropaganda() {
  return <GestaoFundoPropaganda view="client" />;
}
